__turbopack_context__.v({
  "className": "fTcQ8a_className",
  "variable": "fTcQ8a_variable",
});
